const t = {
  name: "Power",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 9V2H11V9H13Z" fill="currentColor"/>
<path d="M5 11.9999C5 9.39358 6.42437 7.11933 8.54265 5.92014L7.55735 4.17969C4.83563 5.7205 3 8.64625 3 11.9999C3 16.9722 7.02772 20.9999 12 20.9999C16.9723 20.9999 21 16.9722 21 11.9999C21 8.64625 19.1644 5.7205 16.4426 4.17969L15.4573 5.92014C17.5756 7.11933 19 9.39358 19 11.9999C19 15.8676 15.8677 18.9999 12 18.9999C8.13228 18.9999 5 15.8676 5 11.9999Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Power
};
